import { inject } from "@angular/core";
import { Router } from "@angular/router";
import { canViewDashboard } from "@app/_helpers/permission";
import { UserSettingsQuery } from "@timeghost/web-api";

export default function SchedulesPageGuard() {
	const userSettings = inject(UserSettingsQuery)?.getValue();
	const router = inject(Router);
	if (!userSettings) return router.createUrlTree(["/"]);
	const user = userSettings.workspace.users?.find((d) => d.id === userSettings.id);
	if (!user) {
		return router.createUrlTree(["/not-found"]);
	}
	const perm = canViewDashboard(userSettings);
	if (!perm || !perm.workingHoursPermission) return router.createUrlTree(["/"]);
	return true;
}
